import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
    selector: '[evkMatSubHeading1]'
})
export class MatSubHeading1Directive {

    @HostBinding('class')
    public class = 'mat-subheading-1';

}
